import dynamic from "next/dynamic"

import { AuthFlowHeaders } from "@/components/auth/auth-flow-headers"
import { Loading } from "@/components/ui/loading"

// The phone step renders only when phone auth is on, so its OTP field, country
// select and as-you-type formatter load when it first renders, not with every
// page. Its own module, like the voice chat boundaries, so specs can mock it to
// the eager component.
export const LazyPhoneSignIn = dynamic(
  () => import("./phone-sign-in").then((mod) => ({ default: mod.PhoneSignIn })),
  {
    // The step opens under this same header, so only its form waits for the chunk.
    loading: () => (
      <>
        <AuthFlowHeaders />
        <Loading className="mx-auto my-8" />
      </>
    ),
  }
)
